import React from 'react';
import { Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import SpbTimeLine from '../SpbTimeLine';

import './SODItem.css';

function SODItem({ sodItem }) {
  return (
    <div className='SODItem'>
      <SpbTimeLine
        iconKind='JobFunctions'
        type='fill'
        kind='sodFunctions'
        showTail={false}
        dataTestId='SODItem-SpbTimeLine'
      />
      <span className='SODItem-details'>
        <Typography kind='body2' className='SODItem-detailsTitle'>
          {sodItem.label}
        </Typography>
        <Typography kind='body3' className='SODItem-detailsDescription'>
          {sodItem.description}
        </Typography>
      </span>
    </div>
  );
}

SODItem.propTypes = {
  sodItem: PropTypes.shape({
    label: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  label: PropTypes.string,
};

SODItem.defaultProps = { label: '' };

export default SODItem;
